import { render, staticRenderFns } from "./InstagramCodeReceiver.vue?vue&type=template&id=46668a76&"
import script from "./InstagramCodeReceiver.vue?vue&type=script&lang=ts&"
export * from "./InstagramCodeReceiver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports